// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionIsEmptyFragmentDoc = gql`
    fragment questionnaireConditionIsEmpty on QuestionnaireConditionIsEmpty {
  __typename
  question {
    id
  }
}
    `;